<template>
	<div class="full">
		<div class="content" style="overflow:hidden;">
			<div class="content_in">
				<div class="title">
					{{article.article_title}}
					
				</div>
				<div class=" container welcome" v-html="article.article_content"></div>
				<div class="btn">
					<div :key="index" class="item" v-for="(item,index) in show_subject" @click="toLogin(item,index)">{{ item.alias_name?item.alias_name:item.subject_name}}</div>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>
<script>

import Footer from '@/components/public/footer'
export default {
	name: 'Index',
	components: {
		Footer
	},
	data() {
		return {
			article:{},
			subject:[],
			show_subject:[]
		}
	},
	created(){

		this.subject = this.$store.state.exam.subject;
		//如果是科目联考，则只显示第一科目
		if(this.$store.state.config.is_series_exam){
			this.show_subject[0] = this.subject[0];
		}else{
			this.show_subject = this.subject;
		}
		this.getWelcome();
		
	},
	computed:{
		project(){
			return this.$store.state.project;
		}
	},
	methods: {
		getWelcome(){
            return this.$req.post("sign/selectArticle",{classify:1}).then(res=>{
                if(res.flag == 1){
					this.article = res.data.articles[0]
                }
            })
		},
		toLogin(item,index){
			let exam = this.$store.state.exam;
			exam.subject[index].use_status = 'ing';
			
			this.$store.commit("exam",exam);
			
			this.$router.push({name:'Login',params:{subject_code:item.subject_code,project_code:this.project.project_code}})
		}
		
	},
}
</script>

<style lang='scss' scope src="../assets/css/index.scss"></style>